
import { Box, Stack, Typography, Divider, Badge, Popover, IconButton } from '@mui/material';
import Iconify from 'src/components/Iconify';
import LabelIcon from 'src/components/LabelIcon';
import { useState } from 'react';

import { Draggable } from 'react-beautiful-dnd';
import { fDateTime, fDateTimeSuffix, fToNow } from 'src/utils/formatTime';
import { formataNumeroCelular } from 'src/utils/functions';
import { CardActionsMenu } from './components/CardActionsMenu';
import { ZuiTooltip } from 'src/@/components/use/tooltip';




export default function NegociosCard({ onOpenDrawerWhatsapp, card, index, onOpen, callbackRefreshLeads, userId, rules }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElConversao, setAnchorElConversao] = useState(null);
    const open = Boolean(anchorEl);
    const openElConversao = Boolean(anchorElConversao);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };


    function exibirQualificacao(valor) {

        // Certifica-se de que o valor seja um número
        const valorNumerico = Number(valor);

        if (valorNumerico < 1 || valorNumerico > 5 || isNaN(valorNumerico)) {
            return <p>Valor inválido!</p>; // Personalize a mensagem de erro
        }

        // Define as cores baseadas no valor
        const colors = {
            1: 'text-blue-200', // Azul
            2: 'text-cyan-500', // Ciano
            3: 'text-yellow-300', // Amarelo
            4: 'text-orange-500', // Laranja
            5: 'text-red-500', // Vermelho
        };

        return (
            <div className="flex flex-row items-center">
                {/* Renderiza os ícones com a cor correspondente */}
                <Iconify
                    key={index}
                    icon="icon-park-solid:fire"
                    className={colors[valorNumerico]}
                />
            </div>
        );
    }


    return (
        <Draggable draggableId={card?._id} index={index}>
            {(provided) => (
                <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                    <Box

                        sx={{
                            textAlign: 'center',
                            border: '1px solid #ddcdff',
                            borderRadius: 1,
                            p: 1,
                            background: '#fff',

                        }}>

                        <Stack spacing={1} direction="column">
                            <Box onClick={onOpen}>
                                <Stack justifyContent={'space-between'} spacing={1} direction="row">

                                    <Stack direction="row" spacing={1}>
                                        {exibirQualificacao(card?.qualificacao)}
                                        <LabelIcon icon="ph:funnel-duotone">{card?.nomeEstagio}</LabelIcon>
                                    </Stack>
                                    <Stack spacing={.5} direction="row">
                                        <p className='text-[10px]'>{card && fToNow(card?.data_modificacao)}</p>
                                    </Stack>
                                </Stack>
                                <Divider sx={{ my: 1, borderStyle: 'dashed' }} />
                                <div className='flex flex-col'>
                                    <div className='text-left'>
                                        <p className='text-xs'>{card?.nome}</p>
                                    </div>
                                    {
                                        card?.whatsapp?.numero && (
                                            <div className='text-left flex flex-row gap-1 items-center mt-2'>
                                                <div className='flex flex-row items-center gap-2'>
                                                    <Iconify className="text-slate-500" width={12} height={12} icon="ri:whatsapp-fill" />
                                                    <p className='text-[12px]'>{formataNumeroCelular(card?.whatsapp?.numero)}</p>
                                                </div>
                                                <div className='text-[10px] bg-slate-100 p-1'>{card?.whatsapp?.lastUpdate && fToNow(card?.whatsapp?.lastUpdate)}</div>

                                            </div>
                                        )
                                    }
                                </div>


                            </Box>
                            <Divider sx={{ my: 0, borderStyle: 'dashed' }} />

                            <Box sx={{ cursor: 'default' }}>
                                <Stack justifyContent={'space-between'} spacing={2} direction="row">
                                    <Stack alignItems={"center"} direction={"row"} spacing={1}>
                                        <CardActionsMenu
                                            callbackRefreshLeads={callbackRefreshLeads}
                                            card={card}
                                            userId={userId}
                                            rules={rules}
                                        />
                                    </Stack>

                                    <div className='flex flex-row gap-2 items-center'>
                                        {card?.contato && card.contato && (
                                            <Stack>
                                                <Box
                                                    sx={{
                                                        pt: .5,
                                                        color: 'action.active',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        '& > *': {
                                                            marginBottom: 0,
                                                        },
                                                        '& .MuiBadge-root': {
                                                            marginRight: 0,
                                                        },
                                                        '& .MuiBadge-badge': {
                                                            width: 1.5,
                                                            height: 6
                                                        },
                                                    }}
                                                >

                                                    <Iconify
                                                        aria-owns={open ? 'mouse-over-popover' : undefined}
                                                        aria-haspopup="true"
                                                        onMouseEnter={handlePopoverOpen}
                                                        onMouseLeave={handlePopoverClose}
                                                        width={18} height={18} icon="mdi:account-circle-outline" />
                                                </Box>
                                                <Popover
                                                    id="mouse-over-popover"
                                                    sx={{
                                                        pointerEvents: 'none',
                                                    }}
                                                    open={open}
                                                    anchorEl={anchorEl}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'left',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'left',
                                                    }}
                                                    onClose={handlePopoverClose}
                                                    disableRestoreFocus
                                                >
                                                    <Box sx={{ width: 200, height: 100, p: 2 }}>
                                                        <Stack direction="column" spacing={0.5}>
                                                            {card?.contato && (
                                                                <Stack direction={"column"} spacing={1}>
                                                                    <Stack alignItems={"center"} spacing={0.5} direction="row">
                                                                        <Iconify width={12} icon="fluent:person-32-filled" />
                                                                        <Typography textAlign={'left'} sx={{ fontSize: 12 }}>{card?.contato?.nome}</Typography>
                                                                    </Stack>

                                                                    <Stack alignItems={"center"} spacing={0.5} direction="row">
                                                                        <Iconify width={12} icon="ic:phone" />
                                                                        <Typography textAlign={'left'} sx={{ fontSize: 12 }}>{card?.contato?.telefone && formataNumeroCelular(card?.contato?.telefone)}</Typography>
                                                                    </Stack>

                                                                    <Stack alignItems={"center"} spacing={0.5} direction="row">
                                                                        <Iconify width={12} icon="ic:email" />
                                                                        <Typography textAlign={'left'} sx={{ fontSize: 12 }}>{card?.contato?.info?.email}</Typography>
                                                                    </Stack>
                                                                </Stack>
                                                            )}
                                                        </Stack>
                                                    </Box>

                                                </Popover>
                                            </Stack>

                                        )}

                                        {card?.closed && (
                                            <ZuiTooltip content="Negócio finalizado">
                                                <div className='mt-1.5'>
                                                    <Iconify icon="lets-icons:flag-finish" className="text-slate-700" />
                                                </div>
                                            </ZuiTooltip>
                                        )}


                                        {card?.convertido && (
                                                <ZuiTooltip content={card?.convertido === 1 ? "Marcado como Venda" : "Marcado como Perda"}>
                                                    <div className='mt-1.5'>
                                                        <Iconify color={card?.convertido === 1 ? 'green' : 'red'} icon="simple-icons:cashapp"/>
                                                    </div>
                                                </ZuiTooltip>
                                        )}
                                        <p className='text-xs pt-1'>
                                            R$ <span className="font-bold">{card?.valor ? card?.valor.toFixed(2) : 0}</span>
                                        </p>

                                    </div>

                                </Stack>

                            </Box>

                        </Stack>

                    </Box>

                </div>
            )}
        </Draggable>
    )
}


















